import {
  isArray,
  isNonEmptyString,
  isNullOrUndefined,
  isUndefined,
} from '@sindresorhus/is';
import type {
  PackageRule,
  PackageRuleInputConfig,
} from '../../config/types.ts';
import { MISSING_API_CREDENTIALS } from '../../constants/error-messages.ts';
import { getApiToken } from '../merge-confidence/index.ts';
import { Matcher } from './base.ts';

export class MergeConfidenceMatcher extends Matcher {
  override matches(
    { mergeConfidenceLevel }: PackageRuleInputConfig,
    { matchConfidence }: PackageRule,
  ): boolean | null {
    if (isNullOrUndefined(matchConfidence)) {
      return null;
    }

    /*
     * Throw an error for unauthenticated use of the matchConfidence matcher.
     */
    if (isUndefined(getApiToken())) {
      const error = new Error(MISSING_API_CREDENTIALS);
      error.validationSource = 'MatchConfidence Authenticator';
      error.validationError = 'Missing credentials';
      error.validationMessage =
        'The `matchConfidence` matcher in `packageRules` requires authentication. Please refer to the [documentation](https://docs.renovatebot.com/configuration-options/#packagerulesmatchconfidence) and add the required host rule.';
      throw error;
    }

    return (
      isArray(matchConfidence) &&
      isNonEmptyString(mergeConfidenceLevel) &&
      matchConfidence.includes(mergeConfidenceLevel)
    );
  }
}
